import Vue from 'vue'
import Router from 'vue-router'
import passIndex from './views/pass.index.vue'
import login from './views/login.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/open/passIndex',
      name: 'passIndex',
      component: passIndex
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
